import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Histórico',
  entries: {
    created: 'Criado por você',
    submitted: 'Enviado por você',
    backToDraft: 'Voltou para rascunho',
    approvedByBodyprint: 'Aprovado pela Equipe Bodyprint',
    rejectedByBodyprint: 'Recusado pela Equipe Bodyprint',
  },
} satisfies TranslationTree;
